import { useQuery } from '@tanstack/react-query';
import { projectsQueries } from '../../api/projectsQueries';

export function useProjects() {
  const debitorQuery = useQuery(projectsQueries.debitors());

  /*
   * FIXME/OPENISSUE/TODO:
   * Is this always index 0 when you query debitors?
   * No! A business partner is allowed to have multiple debitors.
   */
  const debitor0Uuid = debitorQuery.data?.[0]?.uuid;

  /*FIXME/OPENISSUE/TODO: Can debitor uuid be unavailable?*/
  const projectsQuery = useQuery(projectsQueries.projects(debitor0Uuid));

  /*
   * FIXME/OPENISSUE/TODO:
   * Is this always index 0 when you query projects?
   * No! A business partner is allowed to have multiple projects.
   */
  const project0Uuid = projectsQuery.data?.[0]?.uuid;

  const itemsQuery = useQuery(projectsQueries.items(project0Uuid));

  return {
    data: {
      debitors: debitorQuery.data ?? [],
      projects: projectsQuery.data ?? [],
      items: itemsQuery.data ?? [],
    },
    isLoading:
      debitorQuery.isLoading || projectsQuery.isLoading || itemsQuery.isLoading,
    isError:
      debitorQuery.isError || projectsQuery.isError || itemsQuery.isError,
    error: debitorQuery.error || projectsQuery.error || itemsQuery.error,
  };
}
